import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { LocalStorageProvider } from './contexts/LocalStorageContext'
import { AuthenticationProvider } from './contexts/AuthenticationContext'
import { TeamsProvider } from './contexts/TeamsContext'
import { CurrentTeamProvider } from './contexts/CurrentTeamContext'
import { WebSocketProvider } from './shared/websocket'
import App from './App'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <LocalStorageProvider>
      <AuthenticationProvider>
        <TeamsProvider>
          <CurrentTeamProvider>
            <WebSocketProvider>
              <App />
            </WebSocketProvider>
          </CurrentTeamProvider>
        </TeamsProvider>
      </AuthenticationProvider>
    </LocalStorageProvider>
  </StrictMode>
)
